import { useEffect, useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Box, makeStyles, ButtonBase, InputBase, Typography } from '@material-ui/core';
import { eadmissionAPI } from '../../../../../apis';
import { alertMsg } from '../../../../../apis/commlogic';
import { i18n } from '../../../../../language';

const useStyles = makeStyles((theme) => ({
  title: {
    color: '#2E4469',
    fontSize: '1.5rem',
    paddingTop: '1rem',
    paddingBottom: '0.75rem',
  },
  inputText: {
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    width: '60%',
    fontFamily: 'NotoSans-Medium',
    flex: '50%',
    height: '3.5rem',
    lineHeight: '3.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    backgroundColor: '#fff',
    padding: '0 1.25rem',
    color: '#2e4469',
    fontSize: '1rem',
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
    },
    '& .MuiInputBase-input': {
      height: '3.5rem',
      lineHeight: '3.5rem',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  timeStyle: {
    color: '#7D86A9',
    paddingTop: '0.7rem',
    fontFamily: 'Noto Sans',
    fontWeight: '500',
  },
  btn: {
    padding: '1rem 1.75rem',
    backgroundColor: '#4c93ff',
    color: 'white',
    borderRadius: '0.5rem',
    fontSize: '1rem',
    fontWeight: '500',
    '&:disabled': {
      backgroundColor: '#c0c6cb !important',
      color: '#ffffff !important',
    },
  },
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '0 0 1rem 0',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: '1rem 0',
    marginTop: 'auto',
  },
}));

const ShareLinkFolder = () => {
  const classes = useStyles();
  const [value, setValue] = useState({
    folderLinkId: null,
    folderLink: '',
    lastUpdateTime: null,
  });
  const loginInfo = useSelector((state) => state.loginInfo);

  const handleChangeInput = (event) => {
    setValue((oldValue) => ({
      ...oldValue,
      folderLink: event.target.value,
    }));
  };

  const handleSave = async () => {
    try {
      const params = {
        folderLink: value.folderLink,
        hospId: loginInfo.hospitalId,
      };
      await eadmissionAPI.saveShareFloderLink(params);
      alertMsg(i18n.t('DUTYASSIGN_SAVE_SUCCESS_ALERT'), 'alert-success', 'success');
      getShareLink();
    } catch (error) {
      console.log(error);
    }
  };

  const getShareLink = async () => {
    try {
      const { result } = await eadmissionAPI.getShareFloderLink();
      setValue(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getShareLink();
  }, []);

  return (
    <Box className={classes.container}>
      <Box>
        <Box className={classes.title}>Share Folder Link </Box>
        <Box>
          <InputBase className={classes.inputText} value={value.folderLink} onChange={handleChangeInput} />
        </Box>
        {value.lastUpdateTime && (
          <Typography variant="body2" className={classes.timeStyle}>
            late update time : {moment(value.lastUpdateTime).format('HH:mm DD-MM-YYYY')}
          </Typography>
        )}
      </Box>
      <Box className={classes.buttonWrapper}>
        <ButtonBase className={classes.btn} onClick={handleSave} disabled={!value.folderLink}>
          <Box>Save</Box>
        </ButtonBase>
      </Box>
    </Box>
  );
};

export default ShareLinkFolder;
